import React from 'react'
import './portfolio.css'

import { projects } from '../../data/data'

import { DiGitBranch } from 'react-icons/di'
import { BiWorld } from 'react-icons/bi'

function Portfolio() {
  return (
    <section id='portfolio'>
      <h5>My recent Work</h5>
      <h2>Portfolio</h2>
      <div className='container portfolio__container'>
        {projects.map((p, i) => (
          <Project {...p} key={i} />
        ))}
      </div>
    </section>
  )
}

const Project = ({ name, img, gitlink, livelink, desc }) => {
  return (
    <article className='portfolio__item'>
      <div className='portfolio__item-image'>
        <img src={img} alt='' />
      </div>
      <h3>{name}</h3>

      <p className='portfolio__item-summary'>{desc}</p>

      <div className='cta'>
        <a
          target={'_blank'}
          href={'https://github.com/mamt4real/' + gitlink}
          className='btn'
          rel='noreferer'
        >
          Github
          <DiGitBranch className='portfolio__item-icon' />
        </a>
        <a
          target={'_blank'}
          href={livelink}
          rel='noreferer'
          className='btn btn-primary'
        >
          Live Demo
          <BiWorld className='portfolio__item-icon' />
        </a>
      </div>
    </article>
  )
}

export default Portfolio
